import { render } from "./DocLibrary.vue?vue&type=template&id=268c4952"
import script from "./DocLibrary.vue?vue&type=script&lang=js"
export * from "./DocLibrary.vue?vue&type=script&lang=js"

import "./DocLibrary.vue?vue&type=style&index=0&id=268c4952&lang=sass"

import exportComponent from "/home/ploi/orthomatrix.orthosol.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__